<script>
  export default {
    data () {
      return {
        token: null,
      }
    },

    methods: {
      setToken (token) {
        this.token = token

        try {
          localStorage.setItem('token', JSON.stringify(token))
        } catch (e) {
          console.error(`Cannot add token to localStorage`)
        }
      },

      getToken () {
        if (this.token !== null) {
          return this.token
        }

        let token = localStorage.getItem('token')

        if (token === null || token === 'undefined') {
          return null
        }

        // console.info('Token : ', token)
        token = JSON.parse(token)

        this.token = token
        // console.info('Token : ', token)

        return token
      },

      checkLogin () {
        return this.getToken() !== null
      },

      clearToken () {
        this.token = null

        localStorage.clear()
      },
    },
  }
</script>
